import type { ModuleId, ModuleManifest } from '@buildex/module-contract';
import { MODULE_IDS } from '@buildex/module-contract';

/** Человекочитаемые названия модулей для админки */
export const MODULE_LABELS: Record<ModuleId, string> = {
  pricing: 'Ценообразование (App API)',
  dco: 'Динамическое ценообразование',
  sco: 'Статическое ценообразование',
  planner: 'Планировщик',
  marker: 'Разметчик',
};

/**
 * Загрузчики манифестов — источник permissions для конструктора ролей (§9 п.5).
 * Новый модуль автоматически приносит свои права без правок админки.
 */
const MANIFEST_LOADERS: Record<ModuleId, () => Promise<ModuleManifest>> = {
  pricing: () => import('@buildex/module-pricing').then((m) => m.manifest),
  dco: () => import('@buildex/module-dco').then((m) => m.manifest),
  sco: () => import('@buildex/module-sco').then((m) => m.manifest),
  planner: () => import('@buildex/module-planner').then((m) => m.manifest),
  marker: () => import('@buildex/module-marker').then((m) => m.manifest),
};

export interface ModulePermissions {
  moduleId: ModuleId;
  label: string;
  permissions: string[];
}

/** Права активных модулей тенанта, сгруппированные по модулю */
export async function loadModulePermissions(modules: ModuleId[]): Promise<ModulePermissions[]> {
  const active = MODULE_IDS.filter((id) => modules.includes(id));
  const manifests = await Promise.all(active.map((id) => MANIFEST_LOADERS[id]()));
  return manifests.map((manifest, i) => {
    const moduleId = active[i] as ModuleId;
    return { moduleId, label: MODULE_LABELS[moduleId], permissions: manifest.permissions };
  });
}
